"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@angular/material");
var DialogConfigHelper = /** @class */ (function () {
    function DialogConfigHelper() {
    }
    DialogConfigHelper.getConfirmationDialogConfig = function (titleMsgKey, contentMsgKey, contentMsgParams, yesButtonKey, noButtonKey) {
        var dialogConfig = DialogConfigHelper.getDialogBasicConfig();
        dialogConfig.data = {
            titleMsgKey: titleMsgKey,
            contentMsgKey: contentMsgKey,
            contentMsgParams: contentMsgParams,
            yesButtonKey: yesButtonKey,
            noButtonKey: noButtonKey
        };
        return dialogConfig;
    };
    DialogConfigHelper.getWarningDialogConfig = function (title, contentMsgKey, contentMsgParams) {
        var dialogConfig = DialogConfigHelper.getDialogBasicConfig();
        dialogConfig.data = {
            titleMsgKey: title,
            contentMsgKey: contentMsgKey,
            contentMsgParams: contentMsgParams,
        };
        return dialogConfig;
    };
    DialogConfigHelper.getMessageDialogConfig = function (title, contentMsgKey, contentMsgParams) {
        var dialogConfig = DialogConfigHelper.getDialogBasicConfig();
        dialogConfig.data = {
            titleMsgKey: title,
            contentMsgKey: contentMsgKey,
            contentMsgParams: contentMsgParams,
        };
        return dialogConfig;
    };
    DialogConfigHelper.getTypeSubtypeSelectDialogConfig = function (data) {
        var dialogConfig = DialogConfigHelper.getDialogBasicConfig();
        dialogConfig.data = data;
        return dialogConfig;
    };
    DialogConfigHelper.getDialogBasicConfig = function (data) {
        if (data === void 0) { data = {}; }
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.height = 'auto';
        dialogConfig.width = '450px';
        return Object.assign(dialogConfig, data);
    };
    return DialogConfigHelper;
}());
exports.DialogConfigHelper = DialogConfigHelper;
//# sourceMappingURL=dialog-config-helper.js.map